import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilityService } from 'smartauction-frontend-micro-library';

@Component({
  selector: 'app-search-filter-section',
  templateUrl: './search-filter-section.component.html',
  styleUrls: ['./search-filter-section.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SearchFilterSectionComponent {
  @Input() title: string;
  @Input() label: string;
  @Input() open: boolean;
  @Input() variant: 'button' | 'link' = 'button';
  @Input() scrollable = true;
  @Input() analyticsName: string;
  @Input() tagName: string;
  @Output() openChange = new EventEmitter();

  id = this.utilityService.generateId();

  constructor(private readonly utilityService: UtilityService) {}
}
